/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

import { v1 } from 'uuid';
import { AppHostType } from './TeamsUtils';

export enum URIParam {
    Theme = 'theme',
    IsBrowser = 'isBrowser',
    IsMobile = 'isMobile',
    HostClientType = 'hostClientType',
    IsWidget = 'isWidget',
    WidgetId = 'widgetId',
    Origin = 'origin',
}

/**
 * Gets the url parameter
 *
 * @param {string} urlParams The URL params
 * @param {string} name The name
 */
export const getUrlParameter = (urlParams: string, name: string): string | null => {
    const parametersWithoutBrackets = name.replace(/[\[]/g, '\\[').replace(/[\]]/, '\\]');
    const regex = new RegExp('[\\?&]' + parametersWithoutBrackets + '=([^&#]*)', 'i');
    const results = regex.exec(urlParams);
    return results === null ? null : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

/**
 * Returns true if the current platform is Browser
 */
export const isBrowser = (): boolean => {
    const uriComponent = decodeURIComponent(window.location.href);
    const param = getUrlParameter(uriComponent, URIParam.IsBrowser);

    return param && param === 'true';
};

/**
 * Returns true if the current platform is widget
 */
export const isWidget = (): boolean => {
    const uriComponent = decodeURIComponent(window.location.href);
    const param = getUrlParameter(uriComponent, URIParam.IsWidget);

    return param && param === 'true';
};

/**
 * Returns new Guid id
 */
export const newGuid = (): string => {
    return v1();
};

export const emptyGuid = (): string => {
    return '00000000-0000-0000-0000-000000000000';
};

/**
 * Returns the host type of the current platform
 */
export const getHostType = (): AppHostType => {
    if (isBrowser()) {
        return AppHostType.Browser;
    }

    if (isWidget()) {
        return AppHostType.Widget;
    }

    return AppHostType.Teams;
};
